module.exports = __webpack_public_path__ + "assets/img/BTC.ed80d44d.png";